module.exports = __webpack_public_path__ + "img/logo.b703a7ed.svg";